<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import satdosya from "@/models/satdosya";
import DosyaMenu from "./dosyamenu.vue";

import satdosyafirma from "../satdosyafirma/index";
import satdosyamalzeme from "../satdosyamalzeme/index";
import satonaybelgesi from "../SatOnayBelgesi/index";
import piyasaarastirmatutanagi from "../piyasaarastirmatutanagi/index.vue";
import satdosyazarfteslim from "../satdosyazarfteslim/index.vue";
import satdosyaihalekomisyonu from "../satdosyaihalekomisyonu/index.vue";
import satdosyaihaleilani from "../satdosyaihaleilani/index.vue";
import satdosyazarfacmakontrol from "../satdosyazarfacmakontrol/index.vue";
import satdosyakomisyonkarari from "../satdosyakomisyonkarari/index";
import isteklilerceteklifedilenfiyatlar from "../isteklilerceteklifedilenfiyatlar/index.vue";
import kesinlesenihalekarari from "../kesinlesenihalekarari/index";
import sozlesmeyedavet from "../sozlesmeyedavet/index";
import muayenekabul from "../muayenekabul/index";

export default {
  mixins: [apibtoast, apigeneric, satdosya],
  page: {
    title: "Talep",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    satdosyafirma,
    DosyaMenu,
    satdosyamalzeme,
    satonaybelgesi,
    piyasaarastirmatutanagi,
    satdosyazarfteslim,
    satdosyaihalekomisyonu,
    satdosyaihaleilani,
    satdosyazarfacmakontrol,
    satdosyakomisyonkarari,
    kesinlesenihalekarari,
    isteklilerceteklifedilenfiyatlar,
    sozlesmeyedavet,
    muayenekabul,
  },
  data() {
    return {
      DosyaId: this.$route.params.id,
      MenuDisable: "",
      ihaleturu: "",
      aktif_menu: "1100",
      StrBirimHarcamaLimitTutari: "",
      aktif_menu_title: "",
      LimitAsimi: true,

      items: [
        {
          text: this.$t("satdosya.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("satdosya.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("satdosya.Title"),
          active: true,
        },
      ],

      FilitrelemePenceresi: false,
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      Filter: {
        dosyaadi: "",
        Dosyaacilistarih_ilk: "",
        Dosyaacilistarih_son: "",
        ihaleturu: "",
        alimturu: "",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      Dosyamenu: null,
      TutarGuncelle: 0
    };
  },
  methods: {
    Get() {
      if (this.DosyaId != null && this.DosyaId != "") {
        this.ActionsGet({
          Service: "SatDosya/" + this.DosyaId,
          Page: this.Page,
        }).then((res) => {
          this.TableData = res.Data;

          this.ihaleturu = this.TableData.Ihaleturu;
          this.Dosyamenu = JSON.parse(this.TableData.Dosyamenu);
          var OncekiMenuKontrol = false;
          for (let menu in this.Dosyamenu) {
            if (OncekiMenuKontrol == true) {
              this.aktif_menu = menu;
            }
            if (this.Dosyamenu[menu] == true) {
              OncekiMenuKontrol = true;
            } else {
              OncekiMenuKontrol = false;
            }
          }
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-9 col-lg-8">
        <div class="card">
          <div class="card-body p-8">
            <h5>{{ TableData.Dosyaadi }} - {{ aktif_menu_title }}</h5>
            <hr />

            <!-- ÖN HAZIRLIK -->
            <satdosyamalzeme v-if="aktif_menu == 1100" :satdosyaId="DosyaId" @aktif_menu_title="aktif_menu_title = $event" />
            <satdosyafirma v-if="aktif_menu == 1200" :satdosyaId="DosyaId" @aktif_menu_title="aktif_menu_title = $event" @TableUpdate="TutarGuncelle = 1" :StrBirimHarcamaLimitTutari="StrBirimHarcamaLimitTutari" />
            <satonaybelgesi v-if="aktif_menu == 1300" :satdosyaId="DosyaId" @aktif_menu_title="aktif_menu_title = $event" />
            <!-- DOĞRUDAN TEMİN -->
            <piyasaarastirmatutanagi v-if="aktif_menu == 2100" :satdosyaId="DosyaId" @aktif_menu_title="aktif_menu_title = $event" />
            <!-- AÇIK İHALE -->
            <satdosyaihaleilani v-if="aktif_menu == 3100" :satdosyaId="DosyaId" @aktif_menu_title="aktif_menu_title = $event" />
            <satdosyaihalekomisyonu v-if="aktif_menu == 3200" :satdosyaId="DosyaId" @aktif_menu_title="aktif_menu_title = $event" />
            <satdosyazarfteslim v-if="aktif_menu == 3310" :satdosyaId="DosyaId" @aktif_menu_title="aktif_menu_title = $event" />
            <satdosyazarfacmakontrol v-if="aktif_menu == 3320" :satdosyaId="DosyaId" @aktif_menu_title="aktif_menu_title = $event" />
            <isteklilerceteklifedilenfiyatlar v-if="aktif_menu == 3330" :satdosyaId="DosyaId" @aktif_menu_title="aktif_menu_title = $event" />
            <satdosyakomisyonkarari v-if="aktif_menu == 3410" :satdosyaId="DosyaId" @aktif_menu_title="aktif_menu_title = $event" />
            <kesinlesenihalekarari v-if="aktif_menu == 3420" :satdosyaId="DosyaId" @aktif_menu_title="aktif_menu_title = $event" />
            <sozlesmeyedavet v-if="aktif_menu == 3430" :satdosyaId="DosyaId" @aktif_menu_title="aktif_menu_title = $event" />
            <muayenekabul v-if="aktif_menu == 4100" :satdosyaId="DosyaId" @aktif_menu_title="aktif_menu_title = $event" />
          </div>
        </div>
      </div>

      <!-- sağ Menu Alanı -->
      <div class="col-xl-3 col-lg-4">
        <DosyaMenu @MenuDisable="MenuDisable = $event" @aktif_menu="aktif_menu = $event" :ihaleturu="ihaleturu" :Dosyamenu="Dosyamenu" :DosyaId="DosyaId" :AktifMenu="aktif_menu" 
        :TutarGuncelle="TutarGuncelle" @TutarGuncelle2="TutarGuncelle = $event" @StrBirimHarcamaLimitTutari="StrBirimHarcamaLimitTutari = $event"
        />
      </div>
    </div>
  </Layout>
</template>
